import React, { useState } from 'react';

export type Founder = {
  id: string;
  tag: string;
  name: string;
  title: string;
  bio?: string;
  quote?: string;
  photo_url: string;
  initials: string;
};

export function FounderCard({ founder }: { founder: Founder }) {
  const [errored, setErrored] = useState(false);

  return (
    <article className="founder-card">
      <div className="founder-card__portrait">
        {!errored ? (
          <img
            src={founder.photo_url}
            alt={founder.name}
            loading="lazy"
            decoding="async"
            onError={() => setErrored(true)}
          />
        ) : (
          <span>{founder.initials}</span>
        )}
      </div>
      <div className="founder-card__body">
        <div className="founder-card__tag">{founder.tag}</div>
        <div className="founder-card__name">{founder.name}</div>
        <div className="founder-card__title">{founder.title}</div>
        {founder.quote ? (
          <blockquote className="founder-card__quote">
            <p>“{founder.quote}”</p>
            <footer>— {founder.name}</footer>
          </blockquote>
        ) : (
          <p className="founder-card__bio">{founder.bio}</p>
        )}
      </div>
    </article>
  );
}
